import { OrderStatus } from '../types';

type OrdersQuery = {
  query?: string;
  brand?: string;
  groupOrdersOnly?: boolean;
  status?: OrderStatus[];
  notstatus?: OrderStatus[];
  orderSlug?: string;
  from?: string;
  till?: string;
  channelId?: string;
  skipTenantIsolation?: boolean;
};

export const buildOrdersQuery = (filters: OrdersQuery) => {
  const params = new URLSearchParams();
  const globalView = filters.skipTenantIsolation;

  if (filters.query)
    params.set(globalView ? 'kitchenId' : 'kitchen', filters.query);
  if (filters.brand)
    params.set(globalView ? 'brandId' : 'brand', filters.brand);
  filters.status?.forEach((status) => params.append('status', status));
  filters.notstatus?.forEach((status) => params.append('notstatus', status));
  if (filters.orderSlug?.trim())
    params.set('orderSlug', filters.orderSlug.trim());
  if (filters.from) params.set('from', filters.from);
  if (filters.till) params.set('till', filters.till);
  if (filters.channelId) params.set('channelId', filters.channelId);
  if (globalView) params.set('skipTenantIsolation', 'true');

  if (filters.groupOrdersOnly) params.set('groupOrdersOnly', 'true');

  const query = params.toString();

  return query ? `&${query}` : '';
};

export const buildAbandonedOrdersQuery = (
  filters: OrdersQuery & { count?: number }
) => {
  const params = new URLSearchParams();

  if (filters.query) params.set('kitchenId', filters.query);
  if (filters.brand) params.set('brandId', filters.brand);
  if (filters.orderSlug?.trim())
    params.set('orderSlug', filters.orderSlug.trim());
  if (filters.from) params.set('from', `${filters.from}T00:00:00.000Z`);
  if (filters.till) params.set('to', `${filters.till}T23:59:59.999Z`);
  if (filters.count) params.set('limit', String(filters.count));

  if (filters.groupOrdersOnly) params.set('groupOrdersOnly', 'true');

  const query = params.toString();

  return query ? `&${query}` : '';
};
